import type { ComboboxGroupType, ComboboxOptionType } from '../types/combobox-root.types';

/**
 * Type guard to determine if an option is a group
 *
 * @param option - The option to check
 * @returns True if the option is a group, false otherwise
 */
export const isGroup = (
  option: ComboboxOptionType | ComboboxGroupType,
): option is ComboboxGroupType =>
  typeof option === 'object' && option !== null && 'heading' in option;
